import { Injectable } from "@angular/core";
import { ReceivedLabSample } from "../../model/received-lab-sample";
import { DataService } from "../data.service";
import { LaboratoryTubesSearchItem } from "src/app/model/laboratory-tubes/laboratory-tubes-search-item";
import { LaboratoryTubesEdit } from "src/app/model/laboratory-tubes/laboratory-tubes-edit";
import { LaboratoryTubeRejectionReasonFilter } from "src/app/model/laboratory-tubes/laboratory-tube-rejection-reason-filter";
import { AuthService } from "../auth.service";

@Injectable({
  providedIn: "root",
})
export class LaboratoryTubesService {
  constructor(private dataService: DataService, private authService: AuthService) {}

  private readonly endPoint: string = "/laboratorytube";

  async changeStatus(
    tubeIds: number[],
    statusId: number,
    observations: string,
    rejectionReasonId?: number,
    receivedLabNoReceived: boolean = false
  ): Promise<void> {
    await this.dataService
      .post(`${this.endPoint}/ChangeStatus`, {
        tubeIds,
        statusId,
        observations,
        rejectionReasonId,
        receivedLabNoReceived,
        centerId: this.authService.getCenterId()
      })
      .toPromise();
  }

  async revertStatus(tubeIds: number[], observations: string): Promise<void> {
    await this.dataService
      .post(`${this.endPoint}/RevertStatus`, {
        tubeIds,
        observations,
        centerId: this.authService.getCenterId()
      })
      .toPromise();
  }

  async getDetails(tubeId: number): Promise<LaboratoryTubesEdit> {
    return await this.dataService
      .get<LaboratoryTubesEdit>(`${this.endPoint}/GetDetails`, { tubeId })
      .toPromise();
  }

  async getRejectionReasons(): Promise<LaboratoryTubeRejectionReasonFilter[]> {
    return await this.dataService
      .get<LaboratoryTubeRejectionReasonFilter[]>(
        `${this.endPoint}/GetRejectionReasons`
      )
      .toPromise();
  }

  async get(
    dateFrom: Date,
    dateTo: Date,
    viewNoControlled: boolean,
    viewRejected: boolean,
    viewAcepted: boolean,
    label: string,
    clientId?: number,
    patientId?: number
  ): Promise<LaboratoryTubesSearchItem[]> {
    const params = {
      dateFrom: new Date(
        dateFrom.getFullYear(),
        dateFrom.getMonth(),
        dateFrom.getDate()
      ).toDateString(),
      dateTo: new Date(
        dateTo.getFullYear(),
        dateTo.getMonth(),
        dateTo.getDate()
      ).toDateString(),
      viewNoControlled,
      viewRejected,
      viewAcepted,
      label,
      clientId,
      patientId,
    };

    return await this.dataService
      .get<LaboratoryTubesSearchItem[]>(
        `${this.endPoint}/GetByParameters`,
        params
      )
      .toPromise();
  }
}
